import { getDefaultLabels } from './institutionTypes';

export const LABEL_EDITOR_FIELDS = [
  ['student','Student'],['students','Students'],['teacher','Teacher / Faculty'],['teachers','Teachers / Faculty'],
  ['course','Course / Class'],['courses','Courses / Classes'],['section','Section / Batch'],['sections','Sections / Batches'],
  ['branch','Branch / Department'],['branches','Branches / Departments'],['semester','Semester / Term'],['semesters','Semesters / Terms'],
  ['admission','Admission'],['admissionNo','Admission No.'],['enrollmentNo','Enrollment No.'],['rollNo','Roll No.'],
  ['session','Academic Session'],['parent','Parent / Guardian'],['fee','Fee'],['transport','Transport'],['gatePass','Gate Pass'],['certificate','Certificate'],
];

export function resolveLabels(settings={}){
  return { ...getDefaultLabels(settings.institutionType || settings.type), ...(settings.labels || {}) };
}

export function labelFor(settings,key,fallback=''){
  return resolveLabels(settings)[key] || fallback || key;
}
